<template>

  <div class="pdf_main">

    <div class="function_intro">
        终身大会员功能介绍
      </div>

      <div class="first_title">
        目前所有功能
      </div>

      <div class="text_intro">
        永久解锁pdf导出功能、云词库功能
      </div>

      <div class="first_title">
        未来推出所有功能
      </div>

      <div class="text_intro">
        永久解锁未来推出的所有功能
      </div>
    

</div>

  

  
 



  
  

  
    
  </template>
  
  <script>
  export default {
    name: 'DahuiyuanIntroduce',
  
    setup() {
      const images = [
      { src: require('@/assets/1.jpg'), description: '单词默写', isChoosen: true },
      { src: require('@/assets/2.jpg'), description: '释义默写' },
      { src: require('@/assets/3.jpg'), description: '艾宾浩斯' },
      { src: require('@/assets/4.jpg'), description: '中英词表' }
      ];
      
      return { images };
    },
  
    methods: {
      // 在这里添加你的方法
    }
  };
  </script>
  
  <style scoped>

  .pdf_main {
    font-size: 0.4rem;
    margin-left: 0.4rem;
    margin-right: 0.4rem;
    text-align: left;
  }

  

  .text_intro {
    
    color: #000000;
    margin-top: 0.2rem;
    text-align: left;
    
    
    
  }

  .first_title {
    
    color: #000000;
    margin-top: 0.2rem;
    font-size: 0.5rem;
    text-align: left !important;
    display: inline-block; /* 使下划线长度适应文本 */
    border-bottom: 0.04rem solid blue; /* 使用 border-bottom 模拟下划线，并设置颜色为蓝色 */
    color: blue;
    margin-top: 0.5rem;
    font-weight: bold;
    
  }

  .swipe-item {
  display: flex;
  justify-content: center;
  align-items: center;
 
  width: auto; /* 根据图片宽度自动调整 */
}

.image-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}

.swipe-image {
  height: 60vh; /* 设置高度为屏幕高度的一半 */
  object-fit: cover; /* 保持图片比例 */
}

.image-description {
  background-color: blue;
  color: white;
  margin-top: 0.3rem;  
  border-radius: 0.1rem;
  padding: 0.1rem 0.3rem;
  
}

.image-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.function_intro{
    font-size: 0.6rem;
    margin-top: 0.5rem;
    margin-bottom: 0.3rem;
    color: blue;
    text-align: center;
    
  }
  
  </style>